import { BetaBadge } from '@/design-system/components/betaBadge/BetaBadge';
import { H4 } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import React from 'react';

import { DevToolsStackRoutes } from '../types';
import { DevToolsPageNavigation } from './DevToolsPageNavigation';

interface DevToolsPageHeaderProps {
  currentPage: DevToolsStackRoutes;
}

export const DevToolsPageHeader: React.FC<DevToolsPageHeaderProps> = ({ currentPage }) => {
  const HEADER_NAV = [
    {
      labelKey: 'Main',
      value: DevToolsStackRoutes.Main
    },
    {
      labelKey: 'Buttons',
      value: DevToolsStackRoutes.Button
    },
    {
      labelKey: 'Inputs',
      value: DevToolsStackRoutes.Input
    },
    {
      labelKey: 'Texts',
      value: DevToolsStackRoutes.Typography
    },
    {
      labelKey: 'Icons',
      value: DevToolsStackRoutes.Icons
    },
    {
      labelKey: 'Table',
      value: DevToolsStackRoutes.Table
    },
    {
      labelKey: 'Others',
      value: DevToolsStackRoutes.Others
    }
  ];

  return (
    <View sx={styles.container}>
      <H4 bold sx={{ flex: 1, color: '$textPrimary' }}>
        {currentPage} <BetaBadge />
      </H4>
      <DevToolsPageNavigation data={HEADER_NAV} currentPage={currentPage} />
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    mb: '$10',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'relative'
  }
};
